import { FC } from "react";
import PrepState0Svg from "../../public/icons/PrepState0.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpPrepState0Icon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepState0Svg/></span>;
